import { DisplayConfiguration } from '@/common/helios/Tooltip/Base/Content';

function calculateTop(
  pos: string,
  targetItemBox: DOMRect,
  tooltipBox: DOMRect,
  display: DisplayConfiguration
) {
  let top: number;
  const buffer = 10;
  switch (pos) {
    case 'top':
      top = -1 * (tooltipBox.height + buffer) + display.contentOffsetY;
      break;
    case 'bottom':
      top = buffer + display.contentOffsetY + targetItemBox.height;
      break;
    case 'left':
    case 'right':
    default:
      top = -(
        tooltipBox.height / 2 -
        targetItemBox.height / 2 -
        display.contentOffsetY
      );
      break;
  }

  return top;
}

function calculateLeft(
  just: string,
  box: DOMRect,
  display: DisplayConfiguration
) {
  let left: number;
  const buffer = 10;
  switch (just) {
    case 'left':
      left = -1 * (display.width + buffer) + display.contentOffsetX;
      break;
    case 'right':
      left = box.width + buffer + display.contentOffsetX;
      break;
    case 'start':
      left = display.contentOffsetX;
      break;
    case 'end':
      left = box.width - display.width + display.contentOffsetX;
      break;
    default:
      left = box.width / 2 - display.width / 2 + display.contentOffsetX;
      break;
  }

  return left;
}

export function calculatePosition(
  direction: string,
  targetItemBox: DOMRect,
  tooltipBox: DOMRect,
  display: DisplayConfiguration
) {
  const [position, justification = ''] = direction.split('-');
  const vert = ['top', 'bottom'].includes(position) ? position : justification;
  const horz = ['left', 'right'].includes(position) ? position : justification;

  return {
    top: calculateTop(vert, targetItemBox, tooltipBox, display),
    left: calculateLeft(horz, targetItemBox, display)
  };
}
